__turbopack_export_value__({
  "body-logo-18": "MostAppropriate-module-scss-module__hE8orG__body-logo-18",
  "body-text-12": "MostAppropriate-module-scss-module__hE8orG__body-text-12",
  "body-text-14": "MostAppropriate-module-scss-module__hE8orG__body-text-14",
  "body-text-16": "MostAppropriate-module-scss-module__hE8orG__body-text-16",
  "body-text-18": "MostAppropriate-module-scss-module__hE8orG__body-text-18",
  "body-text-20": "MostAppropriate-module-scss-module__hE8orG__body-text-20",
  "body-text-24": "MostAppropriate-module-scss-module__hE8orG__body-text-24",
  "body-text-24-2": "MostAppropriate-module-scss-module__hE8orG__body-text-24-2",
  "body-text-heading-2": "MostAppropriate-module-scss-module__hE8orG__body-text-heading-2",
  "body-text-heading-3": "MostAppropriate-module-scss-module__hE8orG__body-text-heading-3",
  "body-text-medium-14": "MostAppropriate-module-scss-module__hE8orG__body-text-medium-14",
  "body-text-medium-16": "MostAppropriate-module-scss-module__hE8orG__body-text-medium-16",
  "body-text-medium-18": "MostAppropriate-module-scss-module__hE8orG__body-text-medium-18",
  "body-text-medium2-18": "MostAppropriate-module-scss-module__hE8orG__body-text-medium2-18",
  "body-text2-14": "MostAppropriate-module-scss-module__hE8orG__body-text2-14",
  "body-text2-16": "MostAppropriate-module-scss-module__hE8orG__body-text2-16",
  "button-primary-text": "MostAppropriate-module-scss-module__hE8orG__button-primary-text",
  "button-text": "MostAppropriate-module-scss-module__hE8orG__button-text",
  "button2-text": "MostAppropriate-module-scss-module__hE8orG__button2-text",
  "card-shadow": "MostAppropriate-module-scss-module__hE8orG__card-shadow",
  "effect-menu": "MostAppropriate-module-scss-module__hE8orG__effect-menu",
  "header-1": "MostAppropriate-module-scss-module__hE8orG__header-1",
  "main-container": "MostAppropriate-module-scss-module__hE8orG__main-container",
  "main-footer-container": "MostAppropriate-module-scss-module__hE8orG__main-footer-container",
  "main-header-container": "MostAppropriate-module-scss-module__hE8orG__main-header-container",
  "mostAppropriate": "MostAppropriate-module-scss-module__hE8orG__mostAppropriate",
  "mostAppropriate__hoverIcon": "MostAppropriate-module-scss-module__hE8orG__mostAppropriate__hoverIcon",
  "mostAppropriate__item": "MostAppropriate-module-scss-module__hE8orG__mostAppropriate__item",
  "mostAppropriate__link": "MostAppropriate-module-scss-module__hE8orG__mostAppropriate__link",
  "mostAppropriate__list": "MostAppropriate-module-scss-module__hE8orG__mostAppropriate__list",
  "txt-12-bold": "MostAppropriate-module-scss-module__hE8orG__txt-12-bold",
  "txt-14-bold": "MostAppropriate-module-scss-module__hE8orG__txt-14-bold",
  "txt-14-bold-caps": "MostAppropriate-module-scss-module__hE8orG__txt-14-bold-caps",
  "txt-14-med": "MostAppropriate-module-scss-module__hE8orG__txt-14-med",
  "txt-16-bold": "MostAppropriate-module-scss-module__hE8orG__txt-16-bold",
  "txt-16-med": "MostAppropriate-module-scss-module__hE8orG__txt-16-med",
  "txt-18-bold": "MostAppropriate-module-scss-module__hE8orG__txt-18-bold",
  "txt-18-medium": "MostAppropriate-module-scss-module__hE8orG__txt-18-medium",
  "txt-18-medium-24": "MostAppropriate-module-scss-module__hE8orG__txt-18-medium-24",
  "txt-24-semi": "MostAppropriate-module-scss-module__hE8orG__txt-24-semi",
});
